var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "#FFFFFF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_7488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.494 7.96762L11.954 0.967621C11.2089 0.422006 10.3272 0.0934154 9.40677 0.0182844C8.48631 -0.0568467 7.56302 0.124418 6.7393 0.541978C5.91557 0.959539 5.22358 1.59708 4.74006 2.38391C4.25654 3.17073 4.00039 4.0761 4 4.99962V18.9996C4.00016 19.9236 4.25633 20.8294 4.74007 21.6166C5.22382 22.4037 5.91621 23.0415 6.74042 23.459C7.56463 23.8766 8.48841 24.0576 9.40925 23.982C10.3301 23.9063 11.212 23.577 11.957 23.0306L21.497 16.0306C22.1303 15.5662 22.6452 14.9592 23.0002 14.2587C23.3552 13.5582 23.5401 12.7839 23.5401 11.9986C23.5401 11.2133 23.3552 10.4391 23.0002 9.73856C22.6452 9.03806 22.1303 8.43103 21.497 7.96662L21.494 7.96762ZM20.31 14.4176L10.77 21.4176C10.323 21.7442 9.79437 21.9408 9.24257 21.9856C8.69078 22.0304 8.13736 21.9216 7.64357 21.6712C7.14978 21.4209 6.73488 21.0389 6.4448 20.5674C6.15472 20.0958 6.00078 19.5532 6 18.9996V4.99962C5.99445 4.44497 6.1455 3.9 6.43578 3.42734C6.72606 2.95469 7.1438 2.57351 7.641 2.32762C8.06389 2.11251 8.53154 2.00014 9.006 1.99962C9.64189 2.00205 10.2602 2.20851 10.77 2.58862L20.31 9.58862C20.6895 9.86732 20.9981 10.2314 21.2107 10.6515C21.4234 11.0716 21.5343 11.5358 21.5343 12.0066C21.5343 12.4775 21.4234 12.9417 21.2107 13.3618C20.9981 13.7818 20.6895 14.1459 20.31 14.4246V14.4176Z",
    fill: "#FFFFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_7488",
    x: -2.99999,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_7488"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_7488",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.c3cabdb949f6e1ed6e033e8200f21a84.svg";
export { ForwardRef as ReactComponent };